import api from "../../services/api/axios";

export async function sendHelpMessage(payload) {
  const response = await api.post("/help/chat", payload);
  const data = response.data || {};

  return {
    responseId: data.response_id,
    message: data.message,
    links: Array.isArray(data.links) ? data.links : [],
    sources: Array.isArray(data.sources) ? data.sources : [],
    confidence: data.confidence || "none",
  };
}

export async function submitHelpFeedback(responseId, rating) {
  const response = await api.post("/help/feedback", {
    response_id: responseId,
    rating,
  });
  return response.data;
}
